
// Modules
import Common from "./modules/common";
import Animate from "./modules/animate";
import Header from "./modules/header";
import Lightbox from "./modules/lightbox";
import OB from "./modules/outdated-browser";
import WooCommon from "./modules/woo-common";
import QuickCart from "./modules/quick-cart";
import Testimonials from "./modules/testimonials";

// Autoload modules
const modules = [Common, Animate, Header, Lightbox, OB, WooCommon, QuickCart, Testimonials];

modules.forEach((module) => {
  module.init();
});

// import local dependencies
import Router from "./utils/Router";
import pageTemplateTemplateHome from "./partials/template-home";
import pageTemplateTemplateContacts from "./partials/template-contacts";

import pageSearch from "./partials/page-search";
import templateCart from "./partials/template-cart";
import templateCheckout from "./partials/template-checkout";
import singleProduct from "./partials/single-product";
import templateForms from "./partials/template-forms";
import singlePost from "./partials/single-post";
import woocommerceShop from "./partials/archive-product";
import templateCollaboration from "./partials/template-collaboration";
import singleService from "./partials/single-service";

// Populate Router instance with DOM routes
const routes = new Router({
  pageTemplateTemplateHome,
  pageTemplateTemplateContacts,
  pageSearch,
  templateCart,
  templateCheckout,
  templateCollaboration,
  templateForms,
  singleProduct,
  singlePost,
  woocommerceShop,
  singleService
});

// Load Events
$(document).ready(() => routes.loadEvents());
